//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../axios-client';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './IdentitySettingsClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';


export function identitySettingsGetUrl(): string {
  let url_ = getBaseUrl() + "/api/setting-management/identity";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let identitySettingsGetDefaultOptions: Omit<UseQueryOptions<Types.IdentitySettingsDto, unknown, Types.IdentitySettingsDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.IdentitySettingsDto, unknown, Types.IdentitySettingsDto>, 'queryFn'>> = {
};
export function getIdentitySettingsGetDefaultOptions() {
  return identitySettingsGetDefaultOptions;
};
export function setIdentitySettingsGetDefaultOptions(options: typeof identitySettingsGetDefaultOptions) {
  identitySettingsGetDefaultOptions = options;
}

export function identitySettingsGetQueryKey(): QueryKey;
export function identitySettingsGetQueryKey(...params: any[]): QueryKey {
  return trimArrayEnd([
      'IdentitySettingsClient',
      'identitySettingsGet',
    ]);
}
export function __identitySettingsGet(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.identitySettingsGet(
axiosConfig    );
}

/**
 * @return OK
 */
export function useIdentitySettingsGetQuery<TSelectData = Types.IdentitySettingsDto, TError = unknown>(options?: Omit<UseQueryOptions<Types.IdentitySettingsDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useIdentitySettingsGetQuery<TSelectData = Types.IdentitySettingsDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.IdentitySettingsDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  

  options = params[0] as any;
  axiosConfig = params[1] as any;

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.IdentitySettingsDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __identitySettingsGet(context, axiosConfig) : __identitySettingsGet,
    queryKey: identitySettingsGetQueryKey(),
    ...identitySettingsGetDefaultOptions as unknown as Omit<UseQueryOptions<Types.IdentitySettingsDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * @return OK
 */
export function setIdentitySettingsGetData(queryClient: QueryClient, updater: (data: Types.IdentitySettingsDto | undefined) => Types.IdentitySettingsDto, ) {
  queryClient.setQueryData(identitySettingsGetQueryKey(),
    updater
  );
}

/**
 * @return OK
 */
export function setIdentitySettingsGetDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.IdentitySettingsDto | undefined) => Types.IdentitySettingsDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function identitySettingsUpdateUrl(): string {
  let url_ = getBaseUrl() + "/api/setting-management/identity";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function identitySettingsUpdateMutationKey(): MutationKey {
  return trimArrayEnd([
      'IdentitySettingsClient',
      'identitySettingsUpdate',
    ]);
}

/**
 * @param body (optional) 
 * @return OK
 */
export function useIdentitySettingsUpdateMutation<TContext>(options?: Omit<UseMutationOptions<void, unknown, Types.UpdateIdentitySettingsDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.UpdateIdentitySettingsDto, TContext> {
  const key = identitySettingsUpdateMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (body: Types.UpdateIdentitySettingsDto) => Client.identitySettingsUpdate(body),
    mutationKey: key,
  });
}